import React from 'react';
import { Interp, css, toList } from '../../lib/render.jsx';
import { Kruis } from '../Iconen.jsx';

/**
 * Het startmenu, linksonder.
 *
 * Eén kolom met waar je heen kunt. Rechts stond de lijst met iedereen die een
 * plekje aan de paal heeft, zoals XP daar je mappen had; die lijst is nu een knop
 * in dezelfde kolom, en dat scheelt het halve venster.
 *
 * Dit menu gaat ook open zonder account, met dezelfde regels erin: rondkijken mag
 * hier, en wat een naam nodig heeft vraagt er zelf om zodra je het doet. Boven de
 * lijst staat er dan één regel bij, "Inloggen", en de voet houdt zijn uitgang voor
 * zich tot er iets is om uit te loggen. Zie toggleStart in logic/desktop.js.
 *
 * Op de telefoon is dit een schermvullend venster met een donkere achtergrond,
 * zoals elk ander venster daar.
 */
export default function StartMenu({ v }) {
  if (!v.startOpen) return null;
  return (
    <>
      {/* Ernaast klikken sluit het menu, zoals overal. */}
      <div onClick={v.closeStart} style={css(v.startBackStyle)} />
      <div style={css(v.startMenuStyle)}>
        <div style={css(v.startKopStyle)}>
          {v.heeftAvatar
            ? <img alt="" src={v.myAvatar} style={css(v.startKopAvatarStyle)} />
            : <span style={css(v.startLeegStyle)}>?</span>}
          <span style={{ display: 'flex', flexDirection: 'column', gap: '2px', minWidth: '0' }}>
            <span style={css(v.startGroetStyle)}><Interp v={v.startGroet} /></span>
            <span style={css(v.startNaamGrootStyle)}><Interp v={v.startNaamGroot} /></span>
          </span>
          <button onClick={v.closeStart} title="Sluiten" style={css(v.startSluitStyle)}>
            <Kruis maat={20} />
          </button>
        </div>

        <div style={css(v.startBodyStyle)}>
          <div style={css(v.startLinksStyle)}>
            {toList(v.startItems).map((it, $index) => (
              <React.Fragment key={$index}>
                <button onClick={it?.onClick} className="gp-btn" style={css(it?.rijStyle)}>
                  <span style={css(it?.vakStyle)}><Interp v={it?.icoon} /></span>
                  <span style={{ minWidth: '0', flex: '1 1 auto', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    <span style={css(v.startItemTitelStyle)}><Interp v={it?.titel} /></span>
                  </span>
                  {it?.badge ? <span style={css(v.startItemBadgeStyle)}><Interp v={it?.badge} /></span> : null}
                </button>
              </React.Fragment>
            ))}
          </div>

        </div>

        {/* Links de nieuwsregel, rechts de uitgang. */}
        <div style={css(v.startVoetStyle)}>
          <div style={css(v.tickerWrapStyle)}>
            <div className="gp-ticker" style={css(v.tickerRailStyle)}>
              {[0, 1].map((kopie) => (
                <div key={kopie} style={{ display: 'flex', flex: '0 0 auto' }} aria-hidden={kopie === 1 ? 'true' : undefined}>
                  {toList(v.tickerItems).map((t, $index) => (
                    <React.Fragment key={$index}>
                      <span style={css(v.tickerItemStyle)}>
                        <span style={css(v.tickerIconStyle)}><Interp v={t?.icon} /></span>
                        <Interp v={t?.text} />
                      </span>
                    </React.Fragment>
                  ))}
                </div>
              ))}
            </div>
          </div>
          {v.showStartUit ? (
            <button onClick={v.startUitloggen} className="gp-btn" style={css(v.startUitStyle)}>
              Uitloggen
            </button>
          ) : null}
        </div>
      </div>
    </>
  );
}
